/*
 * Copyright (c) 2026 SimplyBook.me Ltd. All rights reserved.
 * Licensed under the Apache License, Version 2.0.
 */

import React, { useState } from "react";
import styled from "styled-components";
import ClientLoginForm from "../booking/ClientLoginForm";
import { CLIENT_LOGIN_VIEW_STATES } from "../../constants/constants";
import { useConfig } from "../../lib/react-query/useConfig";
import ClientLoginView from "./ClientLoginView";
import ClientForgotPasswordView from "./ClientForgotPasswordView";
import Text from "../ui/Text";
import { Popover, PopoverContent, PopoverTrigger } from "../ui/Popover";
import Button from "../ui/Button";
import Icon from "../ui/Icon";

const StyledClientLoginPopover = styled(PopoverContent)`
    display: grid; 
    gap: 24px;
    min-width: 460px;
    padding: 1rem;
    border: 1px solid rgba(${({ theme }) => theme.colors.border.rgba});

    ${({ theme }) => theme.containerMedia.sm} {
        min-width: 100%;
    }
`;


const ClientLoginPopover = () => {
  const [view, setView] = useState(null);
  const { data: config } = useConfig();
  const isRegistrationAllowed = config?.client_login_allow_registration;

  const showLogin = () => setView(CLIENT_LOGIN_VIEW_STATES.LOGIN);
  const showForgotPassword = () => setView(CLIENT_LOGIN_VIEW_STATES.FORGOT_PASSWORD);

  const renderView = () => {
    if (view === CLIENT_LOGIN_VIEW_STATES.LOGIN) {
      return (
        <ClientLoginForm onForgotPasswordClick={showForgotPassword} showRegistrationLink={isRegistrationAllowed} />
      );
    }

    if (view === CLIENT_LOGIN_VIEW_STATES.FORGOT_PASSWORD) {
      return <>
        <Text color="dark" size="large">
          Forgot your password?
        </Text>
        <ClientForgotPasswordView onLoginClick={showLogin} />
      </>;
    }

    return (
      <>
        <Text color="dark" size="large">
          You are not logged in
        </Text>
        <ClientLoginView
          onLoginClick={showLogin}
          allowRegistration={isRegistrationAllowed}
        />
      </>
    );
  };

  return (
    <Popover placement="bottom-right" onOpenChange={(open) => { if (!open) setView(null); }}>
      <PopoverTrigger>
        <Button variant="transparent" size="icon" icon={<Icon.User size={Icon.SIZE.SM}/>} />
      </PopoverTrigger>
      <StyledClientLoginPopover>
        {renderView()}
      </StyledClientLoginPopover>
    </Popover>
  );

};

export default ClientLoginPopover;
